import React from "react";
import Modal from "../../Common/Modal/Modal";
import AddTrainingTypeForm from "./AddTrainingTypeForm";

const AddTrainingTypeModal = ({
  isAddTrainingTypeModal,
  handleAddTrainingTypeModal,
  setTrainingTypes,
  setValue,
}) => {
  return (
    <Modal
      isOpen={isAddTrainingTypeModal}
      heading="Add New Training Type"
      toggle={() => handleAddTrainingTypeModal()}
      width="46.2"
      height="28.9"
      justifyContent="normal"
    >
      <AddTrainingTypeForm
        handleAddTrainingTypeModal={handleAddTrainingTypeModal}
        setTrainingTypes={setTrainingTypes}
        setValue={setValue}
      />
    </Modal>
  );
};

export default AddTrainingTypeModal;
